/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type DonateHeartsControlsContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type HeartDonationCampaignContainer_user$ref: FragmentReference;
export type HeartDonationCampaignContainer_user = {|
  +vcCurrent: ?number,
  +$fragmentRefs: DonateHeartsControlsContainer_user$ref,
  +$refType: HeartDonationCampaignContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "HeartDonationCampaignContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vcCurrent",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "DonateHeartsControlsContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3a487f1ceef9986af1b7092d32e9cd10';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Campaign/__generated__/HeartDonationCampaignContainer_user.graphql.js